// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__X5KGk","head":"styles_head__M+-iW","buttonGroup":"styles_buttonGroup__Tlpyi","button":"styles_button__f64su","buttonTabs":"styles_buttonTabs__Vi+4H"};